import { IEscola } from "@deltasge/marauders-map";

import { createReducer, PayloadAction } from "@reduxjs/toolkit";

import { ActionTypes } from "./types";

export const reducers = createReducer({} as IEscola, {
  [ActionTypes.SET]: (state, action: PayloadAction<IEscola>) => action.payload,
});
